// 开讲课程

// const LiveInfo = () => import('@/comm/LiveInfo.page');
const NormalCourse = () => import('../page/course/NormalCourse/NormalCourse.page');
// const SerialDetail = () => import('../page/SerialDetail.page'); // 老版组合课
const SerialDetail = () => import('../page/course/SeriesCourse.page'); // 新版组合课
const SerialSubInfo = () => import('../page/SerialSub.page');
const XwDetail = () => import('../page/XwDetail.page');
const XwAlbum = () => import('../page/XwAlbum.page');
const XwDetailSub = () => import('../page/XwDetailSub.page');
const VideoDetail = () => import('../page/VideoDetail.page');
const VideoAlbum = () => import('../page/VideoAlbum.page');
const VideoDetailSub = () => import('../page/VideoDetailSub.page');
const FitnessDetail = () => import('../page/FitnessDetail.page');
// const GroupDetail = () => import('../page/GroupDetail.page');  // 老版组合课
const GroupDetail = () => import('../page/course/GroupDetail.page'); // 新版组合课详情页
const ColumnDetail = () => import('../page/course/ColumnDetail/Index.page');
const ChildDetail = () => import('../page/index/ChildDetail.page');
const ExcelentChild = () => import('../page/course/ExcelentChild/Index.page');
const FineClassDetail = () => import('../page/course/FineClassDetail/Index.page');

export default [
  // 开讲课程 type 0
  {
    path: '/info/:liveId(\\d+)',
    name: 'LiveInfo',
    component: NormalCourse,
    meta: {
      pageTitle: '课程详情',
      isCourse: true,
      requiresAuth: false,         // 是否需要登录
      authType: 'user'
    }
  },
  // 系列课详情 type 1
  {
    path: '/info/:liveId(serial-\\d+)',
    name: 'SerialDetail',
    component: SerialDetail,
    meta: {
      pageTitle: '系列课',
      isCourse: true,
      requiresAuth: false,
      authType: 'user'
    }
  },
  // 系列课子课程详情 type 2
  {
    path: '/info/:liveId(serialsub-\\d+)',
    name: 'SerialSubInfo',
    component: SerialSubInfo,
    meta: {
      pageTitle: '系列课',
      isCourse: true,
      requiresAuth: false,
      authType: 'user'
    }
  },
  // 普通微课 type 3
  {
    path: '/info/:liveId(xwdetail-\\d+)',
    name: 'XwDetail',
    component: XwDetail,
    meta: {
      pageTitle: '小微课堂',
      isCourse: true,
      requiresAuth: false,
      authType: 'user'
    }
  },
  // 微课专辑 type 4
  {
    path: '/info/:liveId(xwalbum-\\d+)',
    name: 'XwAlbum',
    component: XwAlbum,
    meta: {
      pageTitle: '小微课堂',
      isCourse: true,
      requiresAuth: false,
      authType: 'user'
    }
  },
  // 微课子课程 type 5
  {
    path: '/info/:liveId(xwsub-\\d+)',
    name: 'XwDetailSub',
    component: XwDetailSub,
    meta: {
      pageTitle: '小微课堂',
      isCourse: true,
      requiresAuth: false,
      authType: 'user'
    }
  },
  // 组合课程详情页 type6/7/8
  {
    path: '/info/:liveId(group-\\d+)',
    // path: '/groupDetail',
    name: 'GroupDetail',
    component: GroupDetail,
    meta: {
      pageTitle: '组合课详情',
      isCourse: true,
      requiresAuth: false,
      authType: 'user'
    }
  },
  // 视频-独立 type 9
  {
    path: '/info/:liveId(video-\\d+)',
    name: 'VideoDetail',
    component: VideoDetail,
    meta: {
      pageTitle: '视频课堂',
      isCourse: true,
      requiresAuth: false,
      authType: 'user'
    }
  },
  // 视频专辑 type 10
  {
    path: '/info/:liveId(videoalbum-\\d+)',
    name: 'VideoAlbum',
    component: VideoAlbum,
    meta: {
      pageTitle: '视频课堂',
      isCourse: true,
      requiresAuth: false,
      authType: 'user'
    }
  },
  // 视频-子课程 type 11
  {
    path: '/info/:liveId(videosub-\\d+)',
    name: 'VideoDetailSub',
    component: VideoDetailSub,
    meta: {
      pageTitle: '视频课堂',
      isCourse: true,
      requiresAuth: false,
      authType: 'user'
    }
  },
  // 训练-独立课程 type 12
  {
    path: '/info/:liveId(fit-\\d+)',
    name: 'FitnessDetail',
    component: FitnessDetail,
    meta: {
      pageTitle: '健身课程',
      isCourse: true,
      requiresAuth: false,
      authType: 'user'
    }
  },
  // 13 训练-系列 14 训练-子课程  15 订阅课父课程  16订阅课子课程  17 精品课

  // 订阅课父课程详情 type 15
  {
    path: '/info/:liveId(column-\\d+)',
    name: 'ColumnDetail',
    component: ColumnDetail,
    meta: {
      pageTitle: '订阅专栏',
      isCourse: true,
      requiresAuth: false,
      authType: 'user'
    }
  },

  // 订阅课子课程详情 type 16
  {
    path: '/info/:liveId(dykdetail-\\d+)',
    name: 'ChildDetail',
    component: ChildDetail,
    meta: {
      pageTitle: '课程详情',
      isCourse: true,
      requiresAuth: false,
      authType: 'user'
    }
  },

  // 精品课父课程课程详情 type 17
  {
    path: '/info/:liveId(finedetail-\\d+)',
    // path: '/fineClassDetail/:liveId',
    name: 'FineClassDetail',
    component: FineClassDetail,
    meta: {
      pageTitle: '课程详情',
      isCourse: true,
      requiresAuth: false,
      authType: 'user'
    }
  },

  // 精品课子课程详情 type 18
  {
    path: '/info/:liveId(jpkdetail-\\d+)',
    name: 'ExcelentChild',
    component: ExcelentChild,
    meta: {
      pageTitle: '课程详情',
      isCourse: true,
      requiresAuth: false,
      authType: 'user'
    }
  }
];



// WEBPACK FOOTER //
// ./src/user/router/course.js